import api from "./api";

// Capa de servicios API del dominio "grupos de WhatsApp" (groups) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const getGroupsDb = (whatsappId) => api.get(`/groups/db/${whatsappId}`);
export const listGroups = (whatsappId) => api.get(`/groups/list/${whatsappId}`);
export const createGroup = (whatsappId, payload) =>
  api.post(`/groups/${whatsappId}`, payload);
export const createGroupsBulk = (whatsappId, payload) =>
  api.post(`/groups/bulk/${whatsappId}`, payload);
export const extractGroupParticipants = (whatsappId, groupId, payload) =>
  api.post(`/groups/${whatsappId}/${groupId}/extract-participants`, payload);
export const exportGroupParticipants = (whatsappId, groupId) =>
  api.get(`/groups/${whatsappId}/${groupId}/participants/export?source=db`, {
    responseType: "blob",
  });
